'use strict';

var $ = require('jquery');

var gtmTracker = require('./tracking/tracking');
var LazyLoader = require('../utils/lazyload');

import {debounce, partial} from '../components/custom-lodash';

var $window = $(window);
var sliderElements = [];
var carouselViews = {};

var prevNext = debounce(function (dir, force, e, context) {
    var that = context;

    if (!that) {
        that = this;
    }

    if (!e && !force) {
        return;
    }

    if (e) {
        e.preventDefault();
    }

    if (!that.scrolling) {
        that.scrolling = true;

        var calcPosition = 0;

        if (that.currentIndex == 0) {
            calcPosition = that.visibleItems;
        } else if (that.currentIndex % that.visibleItems == 0) {
            calcPosition = that.currentIndex + dir * that.visibleItems;
        } else {
            calcPosition = that.currentIndex - (that.currentIndex % that.visibleItems);
        }

        that.goTo(calcPosition).done(function () {
            that.scrolling = false;
        });
        if (that.$carousel[0].children.length > 1 && that.$carousel[0].className.includes('adaptive-slider')) {
            that.$el.find('.nav-progress-indicator .progress-indicator').stop().css({width: '0px'});
            that.animation();
        }
    }
}, 250);

require('jquery-touchswipe');

function CarouselView() {
    return {
        backboneViewFakerInit: function ($el) {
            var that = this;
            var key;
            var method;
            var theMethod;
            var match;

            that.$el = $el;

            that.$ = function (selector) {
                that.$el.find(selector);
            };

            that.trigger = function (event, data) {
                that.$el.trigger(event, data);
            };

            that.on = function (event) {
                that.$el.on(event);
            };

            for (key in that.events) {
                if (that.events[key]) {
                    method = that.events[key];
                    theMethod = method;

                    if (typeof method !== 'function') {
                        theMethod = that[theMethod];
                    }

                    if (theMethod) {
                        match = key.match(/^(\S+)\s*(.*)$/);
                        that.$el.on(match[1], match[2], theMethod.bind(that));
                    }
                }
            }
        },

        events: {
            'click .nav-next': 'next',
            'click .nav-prev': 'prev',
            'click .bubble': 'bubbleClick',
            'click .nav-link': 'navLinkClick',
            'mouseenter .nav-control': 'activateArrow',
            'mouseleave .nav-control': 'deactivateArrow',
            'touchend .nav-control': 'deactivateArrow'
        },
        excludedElements: $.fn.swipe.defaults.excludedElements
            .split(', ')
            .filter(function (elem) {
                return elem !== 'a';
            })
            .join(', '),
        itemWidth: null,
        itemHeight: null,
        currentIndex: 0,
        posAdd: 0,
        maxItems: 0,
        maxItemsAll: 0,
        visibleItems: 1,
        $carousel: null,
        $shadowEl: null,
        $navLinks: null,
        $imageItems: null,
        startSwipeScrollPos: null,
        scrolling: false,
        lastWindowWidth: null,
        automaticChangeTimer: null,
        bubblesInitiated: false,
        navLinksInitiated: false,
        bubblesActiveIcon: 'fa-circle active',
        bubblesInactiveIcon: 'fa-circle-thin',
        isInfinite: false,
        options: {
            infinite: false,
            automaticChangeTime: false,
            showBubbles: true,
            sideBubbles: false,
            speed: 500,
            vertical: false,
            useAlternateDimension: false,
            useNavLinks: false
        },

        initialize: function (config) {
            var that = this;
            var $el = that.$el;
            var $shadowEl = config.$shadowEl;
            var options = config.options;
            var $navLinks = $('.carousel', $el).closest('.carousel-container').find('.nav-link');
            if (options) {
                $.extend(that.options, config.options);
            }
            if ($shadowEl) {
                this.$shadowEl = $shadowEl;
            }
            if ($navLinks.length > 0) {
                this.$navLinks = $navLinks;
                that.options.useNavLinks = true;
            }
            that.isInfinite = that.options.infinite;
            that.backboneViewFakerInit(config.$el);
            that.reinitComplete();
        },
        getImageItems: function () {
            return $('li', this.$carousel);
        },
        preReinit: function () {
            var that = this;
            if (that.isInfinite) {
                that.infiniteItems = that.infiniteItems || 1;
                that.infiniteMin = that.infiniteMin || 2;
                if (that.$carousel) {
                    that.getImageItems().filter('.inf').remove();
                    that.$imageItems = that.getImageItems();
                }
            }
        },
        reinit: function () {
            var that = this;
            var $el = that.$el;
            var $carousel = $('.carousel', $el);
            var $imageItems;

            that.preReinit();
            that.$carousel = $carousel;
            $imageItems = that.getImageItems();
            that.$imageItems = $imageItems;
            that.currentIndex = 0;
            that.maxItems = $imageItems.length;
            that.maxItemsAll = $imageItems.length;
            that.reinitBeforeResponsive();
            that.initResponsive();
        },
        reinitBeforeResponsive: function () {
            var that = this;
            var $imageItems;
            var infiniteItems;
            var $prependItems;
            var $appendItems;
            if (that.isInfinite) {
                $imageItems = that.$imageItems;
                infiniteItems = that.infiniteItems;
                that.isInfinite = false;

                // maybe this needs to get more complex in the future
                // Other values can be configured by the view. Save and restore these values first
                that.posAdd = 0;
                that.noNavDisable = false;

                if ($imageItems.length > that.infiniteMin - 1) {
                    that.isInfinite = true;
                    $prependItems = $imageItems.slice(-infiniteItems).clone();
                    $appendItems = $imageItems.slice(0, infiniteItems).clone();
                    $prependItems.add($appendItems).addClass('inf');
                    that.$carousel.prepend($prependItems).append($appendItems);
                    that.$imageItems = that.getImageItems();
                    that.posAdd = infiniteItems;
                    that.maxItemsAll = that.$imageItems.length;
                    that.noNavDisable = true;
                }
            }
        },
        postReinit: function () {
            var that = this;
            that.goToInt(0, true);
            that.initCarousel();
            that.scrollImages(
                (that.currentIndex + that.posAdd) * (that.options.vertical ? that.itemHeight : that.itemWidth),
                0,
                true
            );
        },
        reinitComplete: function () {
            this.reinit();
            this.postReinit();
        },
        adjustSizeInt: function () {
            var that = this;
            var $el = that.$el;
            var $carouselContainerInner = $('.carousel-container-inner', $el);
            var $imageItems = that.$imageItems;
            var $carousel = that.$carousel;
            var $shadowEl = that.$shadowEl;
            var itemWidth;
            var itemHeight;
            // vertical carousel, default is false
            if (that.options.vertical) {
                if ($shadowEl) {
                    itemHeight = $('li', $shadowEl).height();
                } else {
                    /* fix to take padding and margin in account */
                    itemHeight = $imageItems.outerHeight();
                }

                /* fix to take padding and margin in account */
                if ($imageItems.outerHeight() > $imageItems.height()) {
                    $imageItems.outerHeight(itemHeight);
                } else {
                    $imageItems.height(itemHeight);
                }

                $carousel.height(itemHeight * that.maxItemsAll);
                $carouselContainerInner.css({
                    overflow: 'hidden'
                });
                that.itemHeight = itemHeight;
                that.visibleItems = $carouselContainerInner.length
                    ? Math.round($carouselContainerInner.height() / itemHeight)
                    : 1;
            } else {
                if (that.options.useAlternateDimension) {
                    itemWidth = $carouselContainerInner.width();
                } else if ($shadowEl) {
                    itemWidth = $shadowEl.width();
                } else {
                    $imageItems.add($carousel).css('width', '');

                    /* Optimizely carousels with 2 carts display gets
                    distorted in tablets */
                    const util = require('../utils/util');
                    if ($el.closest('.products-2').length) {
                        if (util.isTablet() || util.isMobile()) {
                            itemWidth = $carouselContainerInner.width();
                        } else {
                            itemWidth = $carouselContainerInner.width() / 2;
                        }
                    } else {
                        /* fix to take padding and margin in account */
                        itemWidth = $imageItems.outerWidth();
                    }
                    $carouselContainerInner.css({
                        overflow: '',
                        'transition-duration': 0
                    });
                }

                // work around for rendering bug in Chrome. Add 1 extra pixel width to overflow half pixels.
                ++itemWidth;

                /* fix to take padding and margin in account */
                if ($imageItems.outerWidth() > $imageItems.width()) {
                    $imageItems.outerWidth(itemWidth);
                } else {
                    $imageItems.width(itemWidth);
                }

                // vertical default is false
                $carousel.width(itemWidth * that.maxItemsAll);
                $carouselContainerInner.css({
                    overflow: 'hidden'
                });
                that.itemWidth = itemWidth;

                that.visibleItems =
                    $carouselContainerInner.length && itemWidth > 0
                        ? Math.round($carouselContainerInner.width() / itemWidth)
                        : 1;
            }
        },
        adjustSize: function (triggeredByResizeEvent) {
            var that = this;
            var windowWidth = $window.width();
            if (!triggeredByResizeEvent || (windowWidth !== that.lastWindowWidth && that.$el.is(':visible'))) {
                that.adjustSizeInt();
                that.bubblesInitiated = false;
                that.goToInt(that.currentIndex, true);
                that.lastWindowWidth = windowWidth;
            }
        },
        initResponsive: function () {
            var adjustSize = this.adjustSize.bind(this);
            $window.on('resize orientationchange', debounce(partial(adjustSize, true), 10));
            adjustSize();
        },
        initCarousel: function () {
            var that = this;
            var startX;
            var startY;
            var dir;
            var isTouch = !!('ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch));
            var isNested = !!this.$el.parents('.carousel-container').length;

            if (that.maxItems > 1 && isTouch && !isNested) {
                that.$carousel
                    .on('touchstart', function (e) {
                        var touch = e.originalEvent.touches[0];
                        startX = touch.clientX;
                        startY = touch.clientY;
                        dir = null;
                    })
                    .on('touchmove', function (e) {
                        var touch = e.originalEvent.touches[0];
                        var deltaX = touch.clientX - startX;
                        var deltaY = touch.clientY - startY;
                        if (!dir) {
                            dir = Math.abs(deltaX) > Math.abs(deltaY) ? 'horizontal' : 'vertical';
                        }
                        if (dir === 'horizontal') {
                            e.preventDefault();
                        }
                    })
                    .on('touchend', function () {
                        dir = null;
                    });
                that.$carousel.swipe({
                    swipeStatus: function (event, phase, direction, distance, duration, fingerCount) {
                        if (fingerCount < 1) {
                            return;
                        }
                        var duration = 0;
                        var currentIndex = that.currentIndex;
                        var itemWidth = that.itemWidth;
                        var itemHeight = that.itemHeight;
                        var posAdd = that.posAdd;
                        var currentIndexPos =
                            (that.options.vertical ? itemHeight : itemWidth) * (currentIndex + posAdd);
                        var scrollImages = that.scrollImages.bind(that);
                        var isALink;
                        var leftOrRight = direction === 'left' || direction === 'right';
                        var posToGo;
                        var getNewIndexPos = function () {
                            var newIndexPos = currentIndexPos;
                            if (direction === 'left') {
                                newIndexPos += distance;
                            } else if (direction === 'right') {
                                newIndexPos -= distance;
                            }
                            return newIndexPos;
                        };
                        var theNewIndexPos = getNewIndexPos();
                        var calculateGoToPos = function () {
                            var tileToShow = theNewIndexPos / (that.options.vertical ? itemHeight : itemWidth);
                            var posInTile = (tileToShow - Math.floor(tileToShow)) * 100;
                            var newPos = currentIndexPos;
                            if (direction === 'left') {
                                newPos = posInTile > 25 ? Math.ceil(tileToShow) : Math.floor(tileToShow);
                            } else if (direction === 'right') {
                                newPos = posInTile < 75 ? Math.floor(tileToShow) : Math.ceil(tileToShow);
                            }
                            return newPos - posAdd;
                        };
                        if (phase === 'start') {
                            that.startSwipeScrollPos = $window.scrollTop();
                        }
                        // If we are moving before swipe, and we are going L or R in X mode, or U or D in Y mode then
                        // drag.
                        if (phase === 'move' && leftOrRight) {
                            scrollImages(theNewIndexPos, duration);
                        } else if (phase === 'cancel') {
                            if (
                                currentIndexPos === getNewIndexPos() &&
                                $window.scrollTop() === that.startSwipeScrollPos
                            ) {
                                that.$carousel.trigger('carousel:tap');
                            }
                            that.startSwipeScrollPos = null;
                            scrollImages(currentIndexPos, that.options.speed);
                        } else if (phase === 'end') {
                            if (leftOrRight) {
                                // posToGo = calculateGoToPos();

                                var calcPosition;
                                var dir = direction == 'left' ? 1 : -1;

                                if (that.currentIndex == 0) {
                                    calcPosition = direction == 'left' ? that.visibleItems : 0;
                                } else if (that.currentIndex % that.visibleItems == 0) {
                                    calcPosition = that.currentIndex + dir * that.visibleItems;
                                } else {
                                    calcPosition = that.currentIndex - (that.currentIndex % that.visibleItems);
                                }

                                posToGo = calcPosition;

                                if (!that.isInfinite) {
                                    // jsimon: don't know why this is done here - goTo function handles this too,
                                    //         keep it for security reasons
                                    posToGo =
                                        posToGo < 0
                                            ? 0 // eslint-disable-line no-nested-ternary
                                            : posToGo > that.maxItems - 1
                                            ? that.maxItems - 1
                                            : posToGo;
                                }
                                that.goTo(posToGo);
                                if (
                                    that.$carousel[0].children.length > 1 &&
                                    that.$carousel[0].className.includes('adaptive-slider')
                                ) {
                                    that.$el
                                        .find('.nav-progress-indicator .progress-indicator')
                                        .stop()
                                        .css('width', '0px');
                                    that.animation();
                                }
                            }
                            isALink = $(event.target).parentsUntil(that.$el, 'a');
                            if (isALink.length) {
                                isALink.one('click', function (e) {
                                    e.preventDefault();
                                });
                            }
                            that.startSwipeScrollPos = null;
                        }
                    },
                    allowPageScroll: 'auto',
                    preventDefaultEvents: false,
                    threshold: 75,
                    excludedElements: that.excludedElements
                });
            }
            that.setNavComponents();
            if (that.$carousel[0].children.length > 1 && that.$carousel[0].className.includes('adaptive-slider')) {
                that.animation();
            }
        },
        scrollValues: function (cssVals, vals, distance, duration, dontScroll) {
            // inverse the number we set in the css
            var that = this;
            var value = (distance < 0 ? '' : '-') + Math.abs(distance).toString();
            var dur;
            if (that.options.vertical) {
                cssVals.transform = 'translate3d(0,' + value + 'px,0)';
            } else {
                cssVals.transform = 'translate3d(' + value + 'px,0,0)';
            }
            vals.transform = value;
            if (!dontScroll) {
                dur = duration / 1000;
                cssVals['transition-duration'] = dur.toFixed(1) + 's';
                vals.duration = dur;
            } else {
                vals.duration = 0;
            }
        },
        scrollImages: function (distance, duration, dontScroll, showFading) {
            var that = this;
            var cssVals = {};
            var vals = {};
            var $carousel = that.$carousel;
            var $whiteCover = $carousel.closest('.carousel-container-inner').find('.white-cover');
            var deferred = new $.Deferred();
            var transitionFinished = function () {
                $carousel.css('transition-duration', '0s');
                deferred.resolve();
            };
            that.scrollValues(cssVals, vals, distance, duration, dontScroll);

            if (dontScroll) {
                if (showFading) {
                    $whiteCover.fadeIn(100, function () {
                        $carousel.css(cssVals);
                        $whiteCover.fadeOut(100);
                    });
                } else {
                    $carousel.css(cssVals);
                }
                transitionFinished();
            } else {
                $carousel.css(cssVals);
            }
            $carousel.one('transitionend', transitionFinished);

            return deferred.promise();
        },
        prev: function (e) {
            var that = this;
            prevNext(-1, false, e, that);
        },
        next: function (e) {
            var that = this;
            prevNext(1, false, e, that);
        },
        nextForced: function (e) {
            var that = this;
            prevNext(1, true, e, that);
        },
        bubbleClick: debounce(function (e) {
            var that = this;
            var $target = $(e.target);
            var targetPage = $target.index();
            that.goTo(targetPage * that.visibleItems);
            if (that.$carousel[0].children.length > 1 && that.$carousel[0].className.includes('adaptive-slider')) {
                that.$el.find('.nav-progress-indicator .progress-indicator').stop().css({width: '0px'});
                that.animation();
            }
        }, 250),
        navLinkClick: debounce(function (e) {
            var that = this;
            var $target = $(e.target);
            var targetPage = $target.closest('.nav-link').index();
            that.goTo(targetPage * that.visibleItems, true, true);
            if (that.$carousel[0].children.length > 1 && that.$carousel[0].className.includes('adaptive-slider')) {
                that.$el.find('.nav-progress-indicator .progress-indicator').stop().css({width: '0px'});
                that.animation();
            }
        }, 250),
        stopAutomaticChange: function () {
            if (this.automaticChangeTimer) {
                window.clearInterval(this.automaticChangeTimer);
            }
        },
        startAutomaticChange: function () {
            var that = this;
            that.stopAutomaticChange();
            that.automaticChangeTimer = window.setInterval(function () {
                that.nextForced();
            }, that.options.automaticChangeTime * 1000);
        },
        goToInt: function (index, dontScroll, showFading) {
            var that = this;
            var currentIndex = that.enforceBoundaries(index);
            var realIndex = that.getRealGoToPos(index);
            var pos = realIndex + 1;
            var sliderID = that.$el[0].id;
            var slider = document.getElementById(sliderID);
            var carouselHeight = $(slider).parent().height();
            var carouselPos = $(slider).parent().offset();
            var sliderElement = $(slider).find('ul.carousel li').eq(pos);

            //active slider
            $(slider).find('li').removeClass('active');
            $(sliderElement).addClass('active');

            //trigger theme
            if ($(sliderElement).hasClass('dark-theme')) {
                $(slider).addClass('dark-theme');
            } else {
                $(slider).removeClass('dark-theme');
            }
            //set nav-title
            //polly-fill for .includes
            if (!String.prototype.includes) {
                String.prototype.includes = function (search, start) {
                    'use strict';
                    if (typeof start !== 'number') {
                        start = 0;
                    }

                    if (start + search.length > this.length) {
                        return false;
                    } else {
                        return this.indexOf(search, start) !== -1;
                    }
                };
            }

            if (that.$carousel[0].children.length > 1 && that.$carousel[0].className.includes('adaptive-slider')) {
                var prevSlide = $(slider)
                        .find('ul.carousel li')
                        .eq(pos - 1),
                    prevDataPromo = prevSlide.attr('data-promo'),
                    prevData = JSON.parse(prevDataPromo),
                    navPrevious = $(slider).find('.navTitlePrev'),
                    nextSlide = $(slider)
                        .find('ul.carousel li')
                        .eq(pos + 1),
                    nextDataPromo = nextSlide.attr('data-promo'),
                    nextData = JSON.parse(nextDataPromo),
                    navNext = $(slider).find('.navTitleNext');

                if (prevData.name != null) {
                    $(navPrevious).html('<p class="nav-title navTitlePrev">' + prevData.name + '</p>');
                    $(navNext).html('<p class="nav-title navTitleNext">' + nextData.name + '</p>');
                } else {
                    $(navPrevious).html('<p class="nav-title navTitlePrev"></p>');
                    $(navNext).html('<p class="nav-title navTitleNext"></p>');
                }
            } else {
                $(slider).find('ul.carousel li').addClass('active');
            }

            //track internal promotions
            if (
                sliderElements.indexOf(pos) === -1 &&
                carouselHeight &&
                carouselPos &&
                carouselPos.top + carouselHeight / 3 > $(document).scrollTop()
            ) {
                sliderElements.push(pos);

                if (sliderElement.length) {
                    var dataPromo = sliderElement.attr('data-promo');

                    if (dataPromo && typeof dataPromo !== typeof undefined) {
                        gtmTracker.trackSliderImpressions(dataPromo);
                    }
                }
            }

            var deferred = new $.Deferred();
            that.stopAutomaticChange();
            that.currentIndex = realIndex;
            that.scrollImages(
                (that.options.vertical ? that.itemHeight : that.itemWidth) * (currentIndex + that.posAdd),
                dontScroll ? 0 : that.options.speed,
                dontScroll,
                showFading
            ).done(function () {
                if (currentIndex !== realIndex) {
                    that.goToInt(realIndex, true).done(function () {
                        deferred.resolve();
                    });
                } else {
                    deferred.resolve();
                }
            });
            that.setNavComponents();
            return deferred.promise();
        },
        goTo: function (index, dontScroll, showFading) {
            var that = this;
            return that.goToInt(index, dontScroll, showFading).done(function () {
                that.trigger('carousel:selected', that.currentIndex);
            });
        },
        getRealGoToPos: function (index) {
            var realIndex;
            var maxItems;
            if (this.isInfinite) {
                realIndex = index;
                maxItems = this.maxItems;
                if (index < 0) {
                    realIndex = maxItems + index;
                } else if (index >= maxItems) {
                    realIndex = index - maxItems;
                }
                return realIndex;
            }
            return this.enforceBoundaries(index);
        },
        getBoundaryMin: function () {
            if (this.isInfinite) {
                return -this.posAdd;
            }
            return 0;
        },
        getBoundaryMax: function () {
            var that = this;
            if (that.isInfinite) {
                return that.maxItems + that.posAdd - that.visibleItems;
            }
            return that.maxItems - that.visibleItems;
        },
        enforceBoundaries: function (index) {
            var that = this;
            return Math.max(Math.min(index, this.getBoundaryMax()), that.getBoundaryMin());
        },
        calcUnlimitedIndex: function (index) {
            var that = this;
            if (index < that.getBoundaryMin()) {
                return that.getBoundaryMax();
            }
            if (index > that.getBoundaryMax()) {
                return that.getBoundaryMin();
            }
            return index;
        },
        getCurrentItem: function () {
            return this.$imageItems.eq(this.currentIndex + this.posAdd);
        },
        setNavComponents: function () {
            var that = this;
            var bubbleIndex;
            var navLinkIndex;
            that.setNavigation();
            if (that.options.automaticChangeTime) {
                that.startAutomaticChange();
            }
            if (that.options.showBubbles) {
                if (!that.bubblesInitiated) {
                    if (!that.options.sideBubbles) {
                        that.createBubbles();
                    }
                    that.bubblesInitiated = true;
                }
                bubbleIndex =
                    that.currentIndex === that.maxItems - that.visibleItems
                        ? -1 // highlight last bubble
                        : Math.floor(that.currentIndex / that.visibleItems);
                that.$el
                    .find('.bubbles .bubble')
                    .addClass(that.bubblesInactiveIcon)
                    .removeClass(that.bubblesActiveIcon)
                    .eq(bubbleIndex)
                    .addClass(that.bubblesActiveIcon)
                    .removeClass(that.bubblesInactiveIcon);
            }
            if (that.options.useNavLinks) {
                if (!that.navLinksInitiated) {
                    that.initNavLinks();
                    that.navLinksInitiated = true;
                }
                navLinkIndex =
                    that.currentIndex === that.maxItems - that.visibleItems
                        ? -1 // highlight last navLink
                        : Math.floor(that.currentIndex / that.visibleItems);
                that.$el
                    .find('.nav-links .nav-link')
                    .addClass('inactive')
                    .removeClass('active')
                    .eq(navLinkIndex)
                    .addClass('active')
                    .removeClass('inactive');
            }
        },
        animation: function () {
            var that = this;
            var navLink = that.$el.find('.nav-links .nav-link.active .nav-progress-indicator .progress-indicator');
            var indicatorDuration = 6000;

            if ($(navLink).hasClass('Slower')) {
                indicatorDuration = 8000;
            } else if ($(navLink).hasClass('Faster')) {
                indicatorDuration = 4000;
            }
            if (navLink.is(':visible')) {
                navLink.animate(
                    {
                        width: '100%'
                    },
                    {
                        duration: indicatorDuration,
                        specialEasing: {
                            width: 'linear'
                        },
                        complete: function () {
                            var targetPage = $(this).closest('.nav-link').index() + 1;
                            that.goTo(targetPage * that.visibleItems, false, false);
                            $('.nav-progress-indicator .progress-indicator').css({width: '0px'});
                            that.animation();
                        }
                    }
                );
            }
        },
        createBubbles: function () {
            var that = this;
            var $bubbleContainer = that.$el.find('.bubble-ctr');
            var $bubbleList = $bubbleContainer.find('.bubbles').empty();
            var $bubble = $('<li/>', {class: 'bubble fa'});
            var bubbleCount = that.visibleItems > 0 ? Math.ceil(that.maxItems / that.visibleItems) : 0;
            var $bubbleContainerWrapper = null;
            var i;
            if (that.visibleItems >= that.maxItems || that.maxItems === 1 || bubbleCount === 0) {
                return;
            }
            if ($bubbleContainer.length === 0) {
                $bubbleContainerWrapper = $('<div/>', {class: 'bubble-ctr-wrapper'});
                $bubbleContainer = $('<div/>', {class: 'bubble-ctr'}).appendTo($bubbleContainerWrapper);
                $bubbleList = $('<ul/>', {class: 'bubbles'}).appendTo($bubbleContainer);
                that.$el.find('.carousel-container-inner').after($bubbleContainerWrapper);
            }
            for (i = 0; i < bubbleCount; i++) {
                $bubbleList.append($bubble.clone());
            }
        },
        initNavLinks: function () {
            var that = this;
            var $carousel = that.$carousel;
            var $whiteCover = $('<div/>', {class: 'white-cover'});
            var $navLinkContainer = that.$el.find('.nav-links');
            if (that.maxItems === 1) {
                return;
            }
            if ($navLinkContainer.length === 0) {
                return;
            }

            $carousel.before($whiteCover);
        },
        setNavigation: function () {
            var that = this;
            var classDisabled = 'disabled';
            var $navPrev = $('.nav-prev', that.$el);
            var $navNext = $('.nav-next', that.$el);
            var elementImage = that.getCurrentItem().find('img');
            var imageData;

            // customized extension to load main images dynamically
            if (elementImage.length !== 0 && elementImage.hasClass('image-placeholder')) {
                imageData = elementImage.data('lgimg');
                elementImage.attr({
                    src: imageData.url,
                    alt: imageData.alt,
                    title: imageData.title
                });

                elementImage.removeClass('image-placeholder');
            }

            if (that.maxItems <= 1 || that.maxItems <= that.visibleItems) {
                $navPrev.add($navNext).addClass(classDisabled).hide();
            } else {
                $navPrev.add($navNext).removeClass(classDisabled).show();
            }

            $navPrev.add($navNext).removeClass(classDisabled);

            if (!that.options.infinite) {
                if (that.currentIndex === that.getBoundaryMin()) {
                    $navPrev.addClass(classDisabled);
                } else if (that.currentIndex === that.getBoundaryMax()) {
                    $navNext.addClass(classDisabled);
                }
            }
        },
        activateArrow: function (e) {
            $(e.currentTarget).addClass('active');
        },
        deactivateArrow: function (e) {
            setTimeout(function () {
                $(e.currentTarget).removeClass('active');
            }, 20);
        }
    };
}

//IE Workaround
function msieversion() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
    var edgeie15 = ua.indexOf('Edge/15');
    var edgeie14 = ua.indexOf('Edge/14');
    var edgeie13 = ua.indexOf('Edge/13');
    var edgeie12 = ua.indexOf('Edge/12');
    var isOldEdge = false;

    if (edgeie15 > 0 || edgeie14 > 0 || edgeie13 > 0 || edgeie12 > 0) {
        isOldEdge = true;
    }

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./) || isOldEdge) {
        if ($('.adaptive-slider').length) {
            $('.adaptive-slider .banner-grid-item').css({
                position: 'relative',
                top: '50%',
                transform: 'translateY(-50%)'
            });
            if ($('.banner-grid-item.h-center').length && $(window).width() > 1023) {
                $('.adaptive-slider .banner-grid-item.h-center').css({
                    position: 'relative',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%,-50%)'
                });
                $('.adaptive-slider .banner-grid-item.h-left').css({
                    position: 'relative',
                    top: '50%',
                    left: '0',
                    transform: 'translate(-20%,-50%)'
                });
                $('.adaptive-slider .banner-grid-item.h-right').css({
                    position: 'relative',
                    top: '50%',
                    left: '0',
                    transform: 'translate(20%,-50%)'
                });
            }

            if ($('.banner-grid-item.h-med-center').length && $(window).width() > 768 && $(window).width() < 1023) {
                $('.adaptive-slider .banner-grid-item.h-med-center').css({
                    position: 'relative',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%,-50%)'
                });
                $('.adaptive-slider .banner-grid-item.h-med-left').css({
                    position: 'relative',
                    top: '50%',
                    left: '0',
                    transform: 'translate(-20%,-50%)'
                });
                $('.adaptive-slider .banner-grid-item.h-med-right').css({
                    position: 'relative',
                    top: '50%',
                    left: '0',
                    transform: 'translate(20%-50%)'
                });
            }
        }
    } else {
        return false;
    }
}

function handleLazyLoadingImages(instance) {
    var lazyLoader = LazyLoader.getInstance();
    if (lazyLoader) {
        var preloadImage = function (i) {
            var $nextItem = this.getImageItems().eq(i);
            if ($nextItem) {
                var nextImage = $nextItem.find('img[data-src]')[0];
                if (nextImage) {
                    LazyLoader.load(nextImage);
                }
            }
        }.bind(instance);

        instance.$el.on('carousel:selected', function (e, i) {
            preloadImage(i + instance.visibleItems);
        });

        preloadImage(instance.currentIndex + instance.visibleItems);
    }
}

module.exports = {
    init: function () {
        $('.carousel-container')
            .not('.loaded')
            .each(function () {
                var $el = $(this);
                var options = $el.data();
                var cv = new CarouselView();

                $el.setUniqueId();
                cv.initialize({$el: $el, options: options});
                $el.addClass('loaded');
                carouselViews[$el.attr('id')] = cv;

                if (!$el.parents('.carousel-container').length) {
                    handleLazyLoadingImages(cv);
                }
            });

        msieversion();
    },
    get: function ($el) {
        return carouselViews[$el.attr('id')];
    }
};
